import React, { ReactNode } from 'react';
import useClientState from './useClientState';
import ClientContext from './ClientContext';

const ClientStateProvider = ({ children }: { children: ReactNode }) => (
  <ClientContext.Provider value={useClientState()}>
    {children}
  </ClientContext.Provider>
);
export default ClientStateProvider;
